import React, { useEffect } from 'react'
import {
  SystemMessagesProvider,
  SystemMessagesViewport,
} from 'Components/Elements/SystemMessages/SystemMessage.styled'
import { useAppStore } from 'Stores/appStoreModuleFed'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { SystemMessage } from './SystemMessage'
import { Trans } from 'react-i18next'

const { REACT_APP_EMAILS_TO_HIDE_NOTIFICATIONS } = process.env
const EMAILS_TO_HIDE = REACT_APP_EMAILS_TO_HIDE_NOTIFICATIONS
  ? REACT_APP_EMAILS_TO_HIDE_NOTIFICATIONS?.split(',')
  : []
const DURATION = 100000000

/*
  Shows system messages in the top center part of the screen.
  Messages are not auto-closing, and can be closed by clicking on the X button.
*/
export const SystemMessages = () => {
  const { email } = useUserStore()
  const { systemMessages, removeSystemMessage } = useAppStore()

  useEffect(() => {
    if (EMAILS_TO_HIDE.includes(email) && systemMessages.length) removeSystemMessage()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email, systemMessages])

  const handleRemoveSystemMessage = (id: string) => () => {
    const systemMessage = systemMessages.find((message) => message.id === id)
    if (systemMessage?.callbackOnClose) systemMessage.callbackOnClose()
    removeSystemMessage(id)
  }

  return (
    <SystemMessagesProvider duration={DURATION} swipeDirection="right">
      <SystemMessagesViewport>
        {!!systemMessages &&
          systemMessages.map((systemMessage) => {
            return (
              <SystemMessage
                key={systemMessage.id}
                type={systemMessage.type}
                onClose={handleRemoveSystemMessage(systemMessage.id)}
              >
                <Trans
                  ns="general"
                  i18nKey={systemMessage.i18config.i18nKey}
                  values={systemMessage.i18config.values}
                  components={systemMessage.i18config.components}
                />
              </SystemMessage>
            )
          })}
      </SystemMessagesViewport>
    </SystemMessagesProvider>
  )
}
